export enum SingleStopReservationType {
  ORIGIN = 'origin',
  DESTINATION = 'destination',
}
